import { FC, useState, useEffect } from 'react'

import ArticleTitle from 'components/articles/parts/article-title/article-title'
import HtmlContainer from 'containers/html-container/html-container'
import LikeShare from 'components/parts/like-share/like-share'
import AuthorLector from 'components/parts/author-lector/author-lector'
import useLectorsSubscription from 'hooks/useLectorsSubscription'

import { PLACEFLAG_ARTICLE } from 'constants/analytic-data'
import { IMaterial } from 'constants/types/webinar.types'
import { getAxiosSingle } from 'pages/api/axios'
import { originShare } from 'utils/analytics/other/share_material/share_material'
import { URL_LIST } from 'constants/url'

import styles from './webinar-read.module.scss'

interface IWebinarRead {
  dataset: IMaterial
  commentsAmmount: number
}

const WebinarRead: FC<IWebinarRead> = ({ dataset, commentsAmmount }) => {
  const [readContent, setReadContent] = useState('')
  const { lectors, subscribeLector } = useLectorsSubscription(dataset.Lecturs, PLACEFLAG_ARTICLE)

  useEffect(() => {
    const getReadContent = async () => {
      const result = await getAxiosSingle(`${URL_LIST.FORMAT_WEBINAR_READ}/${dataset.id}`)
      setReadContent(result.htmlContent)
      console.log(result)
    }
    getReadContent()
  }, [])
  return (
    <>
      <ArticleTitle
        themes={dataset.Themes}
        title={dataset.name}
        startDate={dataset.startDate}
        showLikeShare
        comments={commentsAmmount}
      />
      <div className={styles.whiteBg}>
        <HtmlContainer htmlContent={readContent} />
        <div className={styles.bottom}>
          <LikeShare AData={{ origin: originShare.ARTICLE }} />
        </div>
        {lectors &&
          lectors.map((lectur) => (
            <AuthorLector
              key={lectur.id}
              lectorData={{ ...lectur, small: true }}
              subscribeLector={subscribeLector}
              modificator={styles.author}
              withLink
            />
          ))}
      </div>
    </>
  )
}

export default WebinarRead
